import gql from "graphql-tag";

import {FetchPolicy} from "@khanacademy/wonder-blocks-data";
import {useQuery} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {getInterestsCollectionStatusType} from "./__graphql-types__/index.ts";

const INTERESTS_COLLECTION_STATUS_QUERY: GqlOperation<
    getInterestsCollectionStatusType["response"],
    getInterestsCollectionStatusType["variables"]
> = gqlOp(gql`
    query getInterestsCollectionStatus {
        user {
            id
            isCollectingInterests
        }
    }
`);

export const useIsCollectingInterestsQuery = (): boolean => {
    const [result] = useQuery(INTERESTS_COLLECTION_STATUS_QUERY, {
        fetchPolicy: FetchPolicy.NetworkOnly,
    });

    if (result.status !== "success") {
        return false;
    }

    return result.data.user?.isCollectingInterests ?? false;
};
